<i18n src="@/i18n/components/FormFile.json"></i18n>
<template>
	<div>
		<div
			class="relative bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm flex items-center cursor-pointer hover:bg-gray-50 focus-within:outline-none focus-within:ring-2 focus-within:ring-turquoise">
			<label :for="name" class="relative text-sm pointer-events-none min-w-0">
				<slot v-bind:default="{ file: file, fileSelected: fileSelected, filename: filename }">
					<!-- Show the chosen file name, so the user can tell what is attached -->
					<span v-if="fileSelected" class="flex items-center gap-2 min-w-0">
						<i class="fa fa-paperclip text-gray-400"></i>
						<span class="truncate" :title="filename">{{ filename }}</span>
					</span>
					<span v-else>{{ $t('form_file.select_file') }}</span>
				</slot>
			</label>
			<input :id="name" :name="name" type="file" :multiple="multiple" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md" @input="handleFileSelected($event.target)">
		</div>
	</div>
</template>

<script>
export default {
	name: "FormFile",
	props: {
		value: [Object, File, FileList],
		name: {
			type: String,
			required: true
		},
		multiple: Boolean
	},
	data(){
		return {
			file: null
		}
	},
	watch: {
		// The parent clears the field after sending: keep the label in sync
		value(value) {
			if (!value) this.file = null
		}
	},
	computed: {
		filename() {
			// Multiple selection has no single name: fall back to the file count
			if (this.multiple) {
				const files = Array.from(this.file ?? [])
				return files.length === 1 ? files[0].name : this.$t('form_file.files_selected', [files.length])
			}

			return this.file?.name || this.$t('form_file.file_selected')
		},
		fileSelected() {
			return !!this.file
		}
	},
	methods: {
		/**
		 * Clear the field, so the same file can be picked again
		 * External
		 */
		clear() {
			this.file = null

			const input = document.getElementById(this.name)
			if (input) input.value = ""
		},
		/**
		 *
		 * @param t
		 */
		handleFileSelected(t) {
			this.file = t.files?.length ? this.multiple ? t.files : t.files[0] : null
			this.$emit("input", this.multiple ? t.files : t.files[0])
		}
	}
}
</script>